module.exports = __webpack_public_path__ + "img/2-m.10285f33.jpg";